import React, { useEffect, useState } from "react";
import api from "../../api";
import EmployeeHeader from "../components/Employee/EmployeeHeader";

const EmployeeAlerts = () => {
 const [alerts, setAlerts] = useState([]);
 const [rules, setRules] = useState([]);
 const [loading, setLoading] = useState(true);

 // Responsive handling
 const [isSmall, setIsSmall] = useState(window.innerWidth < 992);

 const fetchAlerts = async () => {
 try {
 const res = await api.get("/employees/stats/alerts");
 if (res.data.success) {
 setAlerts(res.data.alerts || []);
 setRules(res.data.rules || []);
 }
 } catch (err) {
 console.error("Alerts fetch error:", err);
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchAlerts();
 }, []);

 // Handle window resize for responsive UI
 useEffect(() => {
 const onResize = () => setIsSmall(window.innerWidth < 992);
 window.addEventListener("resize", onResize);
 return () => window.removeEventListener("resize", onResize);
 }, []);

 const getAlertStyle = (type) => {
 switch (type) {
 case "warning":
 return { background: "#fff7e0", border: "1px solid #ffe8b3" };
 case "info":
 return { background: "#eaf3ff", border: "1px solid #cfe2ff" };
 case "error":
 return { background: "#fde8e8", border: "1px solid #f5c2c2" };
 default:
 return { background: "#f8f9fa", border: "1px solid #e4e8ef" };
 }
 };

 const getIcon = (type) => {
 switch (type) {
 case "warning":
 return "[WARN]";
 case "info":
 return "";
 case "error":
 return "";
 default:
 return "ℹ";
 }
 };

 if (loading) return <div style={{ padding: 24 }}>Loading...</div>;

 return (
 <div
 style={{
 padding: "24px 32px",
 width: "100%",
 maxWidth: "100%",
 }}
 className="alerts-container"
 >
 <EmployeeHeader />

 {/* ===== Workforce Alerts Section ===== */}
 <div style={cardSection}>
 <h6 style={titleStyle}>Workforce Alerts</h6>
 <small style={descStyle}>Issues requiring attention</small>

 {alerts.length === 0 && (
 <p style={{ marginTop: 12, color: "#6c757d" }}>No alerts </p>
 )}

 <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 14 }}>
 {alerts.map((alert, idx) => (
 <div
 key={idx}
 style={{
 ...alertCard,
 ...getAlertStyle(alert.type),
 flexDirection: isSmall ? "column" : "row",
 alignItems: isSmall ? "flex-start" : "center",
 }}
 >
 <div style={{ display: "flex", gap: 8, alignItems: "flex-start", flex: 1 }}>
 <span style={{ fontSize: 18 }}>{getIcon(alert.type)}</span>

 <div>
 <strong style={{ display: "block" }}>{alert.message}</strong>

 {alert?.workloadPercent !== undefined && (
 <div style={{ fontSize: 12, color: "#d9534f", marginTop: 2 }}>
 Workload: {Math.round(alert.workloadPercent)}%
 </div>
 )}

 {alert.time && (
 <div style={{ color: "#6c757d", fontSize: 12, marginTop: 2 }}>
 {alert.time}
 </div>
 )}
 </div>
 </div>

 <button style={{ ...resolveBtn, marginTop: isSmall ? 10 : 0 }}>Resolve</button>
 </div>
 ))}
 </div>
 </div>

 {/* ===== Rules Section ===== */}
 <div style={{ ...cardSection, marginTop: 24 }}>
 <h6 style={titleStyle}>Auto-Assignment Rules</h6>
 <small style={descStyle}>Configure automatic task distribution</small>

 <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 8 }}>
 {rules.map((rule, index) => (
 <RuleItem key={index} title={rule.title} desc={rule.desc} />
 ))}
 </div>
 </div>
 </div>
 );
};

const RuleItem = ({ title, desc }) => (
 <div style={{ padding: "6px 0" }}>
 <strong style={{ fontWeight: 600 }}>{title}</strong>
 <div style={{ fontSize: 13, color: "#6c757d" }}>{desc}</div>
 </div>
);

/* ===== Styles ===== */

const cardSection = {
 background: "#fff",
 border: "1px solid #e4e8ef",
 borderRadius: "10px",
 padding: "18px",
 width: "100%",
};

const titleStyle = {
 fontWeight: 600,
 marginBottom: 2,
};

const descStyle = {
 fontSize: 12,
 color: "#6c757d",
};

const alertCard = {
 padding: "14px 16px",
 borderRadius: "8px",
 display: "flex",
 justifyContent: "space-between",
 width: "100%",
};

const resolveBtn = {
 padding: "6px 12px",
 border: "1px solid #6c757d",
 background: "#fff",
 borderRadius: "6px",
 fontSize: "13px",
 cursor: "pointer",
 whiteSpace: "nowrap",
};

export default EmployeeAlerts;
